export default __webpack_public_path__ + "static/media/team2.00346ab7.jpg";